export default {
  getAccessTokenLine: function (state) {
    return state.accesstokenLine
  },
  getDataRegister: function (state) {
    return state.dataRegister
  },
  getIsAuthenticated: function (state) {
    return state.isAuthenticated
  },
  businessProfile: function (state) {
    return state.businessProfile
  }
}
